import { Button, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import TableRox from 'src/components/table-rox/TableRox';
import LoadingPage from 'src/components/loading-page/loading-page';
import { useHomeBands } from './home-bands.hook';
import { paths } from 'src/routes/paths';
import { useMyDataStore } from 'src/store/me/me.store';

export default function HomeBands() {
  const hook = useHomeBands();

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.personalization)

  return (
    <Page title="Faixas da Home">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs links={[]} heading="Faixas da Home" action={
          <Button variant="contained" onClick={() => hook.navigate(paths.dashboard.homeBandCreate)} disabled={!permissions?.create}>
            Cadastrar Faixa
          </Button>
        } />
        {hook.isLoading ? (
          <LoadingPage />
        ) : (
          <TableRox
            data={hook.homeBands}
            header={hook.HEADER}
            defaultOrderBy="text"
            hasSearch
            onClickKey="_id"
            onClickFunction={(id) => {
              hook.navigate(paths.dashboard.homeBandDetails(id));
            }}
            selectKey="_id"
          />
        )}
      </Container>
    </Page>
  );
}
